export function resolveContactConfirmCopyKeys(platform: string): {
  readonly messageKey: string;
  readonly confirmLabelKey: string;
} {
  const isWeb = platform === "web";
  return {
    messageKey: isWeb ? "settings.contact.confirmDownload" : "settings.contact.confirm",
    confirmLabelKey: isWeb ? "settings.contact.download" : "settings.contact.send",
  };
}
